import { render, staticRenderFns } from "./OrderActionMessagesTable.vue?vue&type=template&id=97b4109c&scoped=true&"
import script from "./OrderActionMessagesTable.vue?vue&type=script&lang=js&"
export * from "./OrderActionMessagesTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderActionMessagesTable.vue?vue&type=style&index=0&id=97b4109c&lang=scss&scoped=true&"
import style1 from "./OrderActionMessagesTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b4109c",
  null
  
)

export default component.exports